module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAACXBIWXMAAAsSAAALEgHS3X78AAAAw0lEQVRIx7XV0Q2CMBSF4WMncATdhBEcgVHcxDKJjMAIugEb/L7URArYW3J7kj6QkPMl5bYIOAMTtryAGyDrEhCpT28FgqSLlnmrnIek3vCeQvY8JHDwQnJgVF3KCDBm+zt6fhMdLDQjQX7Z3C5PYBPxBlZIkDS3RE5AJ+mpNrmGNPtDI6D/HamIf7p8bj2R6XvQWiBT+g1o75qNHuX/gKPIorwE1CKrcgtgRTbLrUAJ2S2vAfaQv+W1gIA7MKcVS+WAPldRs5f/CwtNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_etiqueta.png
// module id = 205
// module chunks = 0